"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinEntryViewData = void 0;
const assignment_1 = require("../assignment");
const entries_1 = require("../entries");
const PinEntriesViewData_1 = require("./PinEntriesViewData");
var PinEntryViewData;
(function (PinEntryViewData) {
    function data(params) {
        const pin = assignment_1.AssignmentUtils.pin(params.assignment, params.pinId);
        if (!pin || !params.assignmentEntry) {
            return undefined;
        }
        const data = PinEntriesViewData_1.PinEntriesViewData.data({
            assignment: params.assignment,
            entries: params.assignmentEntry ? [params.assignmentEntry] : [],
            pinId: params.pinId,
        });
        if (!data) {
            return;
        }
        const pinEntry = data.pinEntries[0];
        return {
            pinId: data.pinId,
            assignment: data.assignment,
            assignmentEntry: params.assignmentEntry,
            pinContent: data.pinContent,
            pinEntry,
            answer: entries_1.AssignmentEntry.answerForPinEntry(pinEntry),
            result: pinEntry && pinEntry.result,
            type: pin.type,
            pin,
            // } as T;
        }; // TODO @davey: Fix type
    }
    PinEntryViewData.data = data;
})(PinEntryViewData || (exports.PinEntryViewData = PinEntryViewData = {}));
//# sourceMappingURL=PinEntryViewData.js.map